import { ChatChannel } from '../../../types/chat';

export const CHAT_CHANNELS: ChatChannel[] = ['general', 'game', 'spectate'];
